import { getSeoArticleByPath } from "./articleCatalog";

const defaultTitle = "Entraînement sur-mesure pour tous les niveaux | Hop La Coaching";

export function getSeoTitle(location: string) {
    const article = getSeoArticleByPath(location);
    if (article) return article.title;

    let title = "";
    switch (location)
    {
        case "/forgot-password":
        case "/client":
        case "/coach":
        case "":
        case "/": title = defaultTitle; break;
        case "/acces-membre": title = "Connectez-vous à votre compte Hop La Coaching"; break;
        case "/defiscalisation-immediate":
        case "/defiscalisation-immédiate": title = "Coach sportif à moitié prix avec l'avance immédiate | Hop La Coaching"; break;
        case "/gym-douce-bien-etre": title = "Entraînement de gym douce pour se remettre en forme | Hop La Coaching"; break;
        case "/boxe-entrainement": title = "Réservez votre séance de boxe en ligne | Hop La Coaching"; break;
        case "/sport-et-fitness": title = "Coaching sportif pour atteindre vos objectifs de fitness | Hop La Coaching"; break;
        case "/conditions-generales-de-vente": title = "Mentions légales Hop La Coaching : politique de confidentialité"; break;
        case "/conditions-generales-de-vente-hoplacoaching": title = "Hop La Coaching : conditions générales de vente et de réservation"; break;
        case "/contact": title = "Contactez Hop La Coaching | Coach sportif à domicile"; break;
        case "/articles": title = "Articles coaching sportif à domicile | Hop La Coaching"; break;
        default: title = defaultTitle; break;
    }

    return title;
}

